"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckPsw = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable consistent-return */
/* eslint-disable max-len */
const react_1 = require("react");
// import { AssetType } from 'types/asset-type'
// eslint-disable-next-line import/no-extraneous-dependencies
const react_i18next_1 = require("react-i18next");
const sdk_1 = __importDefault(require("@twa-dev/sdk"));
const wallet_1 = require("../../../logic/wallet");
const checkpsw_module_css_1 = __importDefault(require("./checkpsw.module.css"));
const pinpad_1 = require("../../../components/pinpad");
const getClient_1 = require("../../../utils/getClient");
const CheckPsw = (props) => {
    const TgObj = sdk_1.default;
    const { t } = (0, react_i18next_1.useTranslation)();
    const wall = new wallet_1.CustomWallet((0, getClient_1.getDeLabClient)());
    const [createAnimation, setCreateAnimation] = (0, react_1.useState)(undefined);
    function enableBtn() {
        TgObj.MainButton.disable();
        TgObj.MainButton.show();
        TgObj.MainButton.text = t('swap-modal.sending-loading');
        TgObj.MainButton.color = '#424B56';
        // if (props.position === 1 && (props.tokenBalance1.length.toString() === '0')) {
        //     TgObj.MainButton.text = t('swap-modal.confirm-swap')
        //     TgObj.MainButton.color = '#424B56'
        //     TgObj.MainButton.disable()
        // } else if (props.position === 1 && (props.tokenBalance1.length.toString() !== '0')) {
        //     TgObj.MainButton.color = '#007AFF'
        //     TgObj.MainButton.text = t('swap-modal.confirm-swap')
        //     TgObj.MainButton.enable()
        // }
    }
    const handleBtnClick = async () => {
        const checkPsw = await wall.getPrivateKey(props.psw.value);
        if (typeof checkPsw === 'object') {
            setCreateAnimation('failure');
            return;
        }
        setCreateAnimation('success');
        TgObj.MainButton.showProgress();
        await props.swapMakeToCompl();
    };
    (0, react_1.useEffect)(() => {
        if (props.psw.value.length === 4 && (props.tokenBalance1.length.toString() !== '0')) {
            handleBtnClick();
        }
    }, [props.psw.value, props.psw.value.length, props.tokenBalance1]);
    (0, react_1.useEffect)(() => {
        if (props.position !== 1)
            return;
        enableBtn();
        // TgObj.MainButton.onClick(handleBtnClick)
        return () => {
            // TgObj.MainButton.offClick(handleBtnClick)
        };
    }, [props.position === 0, props.tokenBalance1.length.toString() === '0', props.tokenBalance1, props.position, props.psw, props.psw.value]);
    function enableBackBtn() {
        TgObj.BackButton.show();
    }
    (0, react_1.useEffect)(() => {
        enableBackBtn();
        TgObj.BackButton.onClick(props.handleBack);
        return () => {
            TgObj.BackButton.offClick(props.handleBack);
        };
    }, []);
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)("div", { className: checkpsw_module_css_1.default.passwordBlock, children: (0, jsx_runtime_1.jsx)(pinpad_1.PinPad, { title: t('pincod.enter'), onChange: e => props.psw.change(e), animationState: createAnimation, setAnimationState: setCreateAnimation }) }) }));
};
exports.CheckPsw = CheckPsw;
